// sns-components
import IconButton from '../../sns-components/kit-components/buttontemplates/IconButton'

import DatepickerDropdown from '../../sns-components/kit-components/datepicker/DatepickerDropdown'

import BooleanInput from '../../sns-components/kit-components/input-templates/boolean/BooleanInput'
import CheckboxInput from '../../sns-components/kit-components/input-templates/checkbox/CheckboxInput'
import DateInput from '../../sns-components/kit-components/input-templates/date/DateInput'
import DateInputView from '../../sns-components/kit-components/input-templates/date/DateInputView'
import SwitchInput from '../../sns-components/kit-components/input-templates/switch/SwitchInput'

import SNSelect from '../../sns-components/kit-components/input-templates/selection/SNSelect'
import SNSelectWrapper from '../../sns-components/components/Inputs/Selection/SNSelectWrapper'

const SnsComponents = function (Vue) {
  // sns ui-kit components
  Vue.component('p4a-icon-button', IconButton)// p4a-icon-button

  Vue.component('p4a-date-dropdown', DatepickerDropdown)// p4a-date-dropdown

  Vue.component('sns-pillbox', BooleanInput) // p4a-pillbox
  Vue.component('sns-checkbox', CheckboxInput) // p4a-checkbox
  Vue.component('sns-date-input', DateInput) // p4a-date-input
  Vue.component('sns-date-input-view', DateInputView) // p4a-date-input-view
  Vue.component('sns-switch', SwitchInput) // p4a-switch

  Vue.component('sn-select', SNSelect) // sn-select
  Vue.component('sn-select-wrapper', SNSelectWrapper) // sn-select
};

export default SnsComponents



//////////////////
// WEBPACK FOOTER
// ./node_modules/pro4all-ui/plugins/componentLists/Sns-components.js
// module id = null
// module chunks = 